import React from "react";
import { useTheme } from "@mui/material/styles";

const OutboundInsuranceReenrollmentIcon = () => {
  const theme = useTheme();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 100 100"
      fill="none"
    >
      <circle
        cx="50"
        cy="50"
        r="48.5"
        fill={theme.palette.tertiary[100]}
        stroke={theme.palette.tertiary[300]}
        strokeWidth="1.5"
      />
      <g
        fill="none"
        stroke={theme.palette.primary[500]}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M26 44a24 24 0 0 1 42-12" />
        <path d="M69 24v9h-9" />
        <path d="M74 56a24 24 0 0 1-42 12" />
        <path d="M31 76v-9h9" />
      </g>
      <rect
        x="36"
        y="40"
        width="28"
        height="20"
        rx="3.5"
        fill={theme.palette.secondary[400]}
        stroke={theme.palette.primary[500]}
        strokeWidth="3.2"
      />
      <path
        d="M50 44.5l-5 2v3.5c0 3 2 5.5 5 6.5c3-1 5-3.5 5-6.5v-3.5z"
        fill={theme.palette.system[0]}
        stroke={theme.palette.error[400]}
        strokeWidth="2.4"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OutboundInsuranceReenrollmentIcon;
